<script lang="ts">
  import Button from "$lib/elements/Button.svelte";
  import {userService} from "$lib/services/user.service";
  import {toasts} from "$lib/stores/toastStores";
  import type {IDepositOffer} from "$lib/interfaces/IDepositOffer";
  import {countdownTimer} from "$lib/utils/countdown";
  import {createEventDispatcher} from "svelte";

  interface Props {
    item: IDepositOffer;
  }

  let { item = $bindable() }: Props = $props();
  let dispatch = createEventDispatcher();

  function depositOffer() {
    item.activated = !item.activated;
    userService.depositOffer(item.id, item.activated).then(() => {
      toasts.send(`Offer ${item.activated ? 'activated' : 'deactivated'}`, item.activated ? 'success' : 'info');
      dispatch('offerActivated', item);
    }).catch(() => {
      toasts.send('Failed to activate offer', 'error');
    })
  }
</script>

<div class="border-2 border-primary-fire p-5 md:p-6 w-full grid grid-cols-4 rounded-2xl">
  <div class="col-span-1 pr-2">
    <img src={item.image.fileUrl} alt="" class="w-full h-full object-cover aspect-[2/3] rounded-xl"/>
  </div>
  <div class="col-span-3 px-2">
    <span>{item.title}</span>
    <div class="text-xs flex flex-col gap-1.5 mt-2">
      {#each item.properties as property}
        <div class="flex justify-between">
          <span>{property.key}</span>
          <span>{property.value}</span>
        </div>
      {/each}
    </div>
  </div>
  <div class="col-span-4 flex justify-between items-center mt-3">
    <div>
      {#if item.expiresAt}
        <span class="text-white text-sm">Expires in: <span class="text-primary-fire">{countdownTimer(item.expiresAt)}</span></span>
      {/if}
    </div>
    {#if item.activated}
      <Button on:click={() => depositOffer()}>{'Deactivate'}</Button>
    {:else}
      <Button variant="secondary" on:click={() => depositOffer()}>{'Activate'}</Button>
    {/if}
  </div>
</div>
